<template>
	<div>
		<ul class="nav nav-tabs md-tabs " role="tablist">
            <li class="nav-item">
                <a class="nav-link active" data-toggle="tab" href="#view_questions" role="tab">CBT Questions</a>
                <div class="slide"></div>
            </li>
            <li class="nav-item">
                <a class="nav-link" data-toggle="tab" href="#add_questions" role="tab">Add Questions</a>
                <div class="slide"></div>
            </li>
        </ul>

        <div class="tab-content card-block">

            <div class="tab-pane active" id="view_questions" role="tabpanel">
            	<ListCbtQuestions v-bind:id="id" />
            </div>

            <div class="tab-pane" id="add_questions" role="tabpanel">
	        	<AddCbtQuestions v-bind:id="id" />
            </div>

        </div>

	</div>
</template>

<script>
	import AddCbtQuestions from './AddCbtQuestions'
	import ListCbtQuestions from './ListCbtQuestions'
	export default{
		name: "CBTComponent",
		props:{
			id:{
				required: true,
				type: Number
			}
		},
		data(){
			return{}
		},
		components:{
			AddCbtQuestions,
			ListCbtQuestions
		}
	}
</script>